import { Company } from "./company";
import { FloorTable } from "./floor-table";
import { PersonAccount } from "./person-account";
import { Pricebook } from "./pricebook";
import { PrintedInvoiceHistory } from "./printed-invoice-history";
import { Recordtype } from "./recordtype";
import { SaleOrderDetail } from "./sale-order-detail";
import { ShipmentDetail } from "./shipment-detail";
import { SystemField } from "./system-field";

export class SaleOrder extends SystemField{
    
    so_type?:string;
    order_num?:string;
    status?:string;
    order_date?:string;
    requested_on?:string;
    location_id?:string;
    customer_id?:string;
    project_id?:string;
    ordered_qty?:number;
    discount_total?:number;
    vat_exempt_total?:number;
    vat_taxable_total?:number;
    tax_total?:number;
    order_total?:number;
    saler_id?:string;
    record_type_id?:string;
    sub_total?:number;
    table_no?:string;
    people?:number;
    checkout_date?:string;
    shipped_qty?:number;
    discount_rate?:number;
    floor_table_id?:string;
    is_end_shift?:number;
    staff_shifts_id?:string;
    printed_inv?:number;
    completed_by_id?:string;
    transaction_date?:string;
    due_balance?:number;
    channel?:string;
    store_id?:string;
    prepayment_ids?:string;
    pricebook_id?:string;
    delivery_id?:string;

    //formula fields
    duration?:string;
    grand_total?:number;
    shipment_count?:number;
    invoices_count?:number;
    total_cost?:number;

    langs?:any;
    record_type?:Recordtype;
    customer?:PersonAccount;
    table?:FloorTable;
    order_details?:SaleOrderDetail[];
    active_order_details?:SaleOrderDetail[];
    printed_invoice_histories?:PrintedInvoiceHistory[];
    pricebook?:Pricebook;
    shipment_detail?:ShipmentDetail[];
    store?:Company;
    delivery?:PersonAccount;

}
export class SaleOrderTranslation extends SystemField{
    
    lang_code?:string;
    short_desc?:string;
    sales_order_id?:string;
}
